/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import "./layout.css"
import styles from "./layout.module.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  // Function to generate obfuscated email link
  const generateContactLink = () => {
    // Simple obfuscation: split the email components
    const user = ["s", "u", "p", "p", "o", "r", "t"].join("");
    const domain = ["d", "r", "e", "a", "m", "o", "o", "n", ".", "a", "i"].join("");
    const subject = "Contact from ServerCat.app";
    const body = "from https://servercat.app";
    return `mailto:${user}@${domain}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1rem`,
        }}
      >
        <main className={styles.main}>{children}</main>

        <footer>
          © {new Date().getFullYear()} · <a href={generateContactLink()}>Contact US</a>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
